// extracted by mini-css-extract-plugin
export default {"header":"LI","container":"MI","accordeonitem":"NI","itemsticky":"OI","itemopen":"PI","open":"QI","productname":"RI","productinfo":"SI","flavorstext":"TI","invalidlimit":"UI","limit":"VI","scrollUpAccordion":"WI","wrapper":"XI"};
    if(module.hot) {
      // 1738836197196
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  